import { Button, Modal, Skeleton, Space, Typography } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useDeleteSeries, useFetchSeasonFixtures } from "../../entities/api";

const RemoveSeries = ({ series }) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const handleOpenModal = () => setOpenModal((prev) => !prev);
  const {
    data: fixtures,
    isLoading: loadingFetchFixtures,
    refetch: fetchFixtures,
  } = useFetchSeasonFixtures({
    seriesCode: series?.seriesCode,
  });
  const { mutateAsync: deleteFn, isPending: isDeletePending } = useDeleteSeries();

  const handleRemoveRequest = async () => {
    try {
      await deleteFn(series?.seriesCode);
      handleOpenModal();
    } catch (e) {
      console.error(e);
    }
  };

  const ContentForModalWindow = () => {
    if (fixtures?.data?.length) {
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography.Text>You can't delete this series as it has been linked to a fixture(s)</Typography.Text>
          <Typography.Text>Please remove the series from the fixture if you wish to delete this series</Typography.Text>
        </div>
      );
    }

    return (
      <Space direction="vertical" size={1}>
        <>
          <Typography.Text>
            Delete series <Typography.Text strong>{series?.nameLocal}</Typography.Text>?
          </Typography.Text>
          <Typography.Text>
            Status:{" "}
            <Typography.Text strong>
              {formatMessage({
                id: `series.status.${series.status}`,
                defaultMessage: series.status,
              })}
            </Typography.Text>
          </Typography.Text>
          <Typography.Text>
            Series Type:{" "}
            <Typography.Text strong>
              {formatMessage({
                id: `series.type.${series.seriesType}`,
                defaultMessage: series.seriesType,
              })}
            </Typography.Text>
          </Typography.Text>
        </>
      </Space>
    );
  };

  const removeSeries = () => {
    handleOpenModal();
    fetchFixtures();
  };

  return (
    <>
      <Button onClick={removeSeries} size={"small"} type={"text"} icon={<i className="fas fa-trash" />} />
      <Modal
        title={formatMessage({
          id: "series.delete",
          defaultMessage: "Delete Series",
        })}
        open={openModal}
        okButtonProps={{
          danger: true,
          disabled: fixtures?.data?.length > 0,
          loading: isDeletePending,
        }}
        okText={formatMessage({
          id: "delete",
          defaultMessage: "Delete",
        })}
        onCancel={handleOpenModal}
        onOk={handleRemoveRequest}
      >
        {loadingFetchFixtures ? <Skeleton /> : <ContentForModalWindow />}
      </Modal>
    </>
  );
};

export default RemoveSeries;
